let HOST = "https://api.lifeworthlivingfilm.com/api/v1/";
export const BASE_URL = "https://api.lifeworthlivingfilm.com/api/v1/";
export const BASE_URL_IMAGE = "https://api.lifeworthlivingfilm.com/images/";
export const BASE_URL_VIDEO = "https://api.lifeworthlivingfilm.com/videos/";

export default HOST;